import Alpine from "./Alpine";
import "../Fusion/Module/TopNews";
import "../Fusion/Module/Slider";
import "../Fusion/Module/PeopleNews";
import lazySizes from "lazysizes";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/aspectratio/ls.aspectratio";
import "lazysizes/plugins/native-loading/ls.native-loading";
import "Packages/Plugins/Garagist.Fontawesome.AlpineJS/Resources/Private/Main";
import initLoader from "Packages/Carbon/Carbon.FileLoader/Resources/Private/Assets/Loader";
import eventListener from "Packages/Carbon/Carbon.FileLoader/Resources/Private/Assets/EventListener";

initLoader({
    callback: () => Alpine.start(),
});

document.addEventListener("Neos.NodeCreated", () => {
    initLoader();
});

eventListener(
    "loader:markup",
    ({ detail }) => {
        const { markup, callback } = detail;
        if (markup) {
            // Loads additional components before rendering
            initLoader({ markup, callback });
        }
    },
    false,
);

lazySizes.cfg.nativeLoading = {
    disableListeners: {
        focus: true,
        mouseover: true,
        click: true,
        transitionend: true,
        animationend: true,
        scroll: true,
    },
};
